import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { AddCartLinesApiParameter, addLineCollection } from "@insite/client-framework/Services/CartService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { CartLineCollectionModel, CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";
import { CustomApiHandler } from "@WhiteCapInternal/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface ProductWithQtyApiParameter extends ProductModel {
    qty: number;
}

export interface PromoProductApiParameter {
    products: ProductWithQtyApiParameter[];
}

type HandlerType = CustomApiHandler<PromoProductApiParameter>;

export const PromotionCartBeingLoaded: HandlerType = async props => {
    props.dispatch({
        type: "Custom/PromotionCart/BeginLoadProducts",
    });
};

export const PromotionCartAPICall: HandlerType = async props => {
    const products = props.parameter.products;
    const state = props.getState() as unknown as CustomApplicationState;
    const promotionId = state.WhiteCap.promotionProducts.promotionId;

    const cartLineCollection = {
        cartLines: products.map(item => {
            const unitOfMeasure = item.unitOfMeasures?.find(item => item.isDefault)?.unitOfMeasure;
            return {
                productId: item.id,
                qtyOrdered: item.qty,
                unitOfMeasure: unitOfMeasure,
                properties: {
                    ChoiceOfFreeProductPromotionId: promotionId,
                } as any,
            } as CartLineModel;
        }),
    } as CartLineCollectionModel;

    const parameter = {
        cartId: API_URL_CURRENT_FRAGMENT,
        cartLineCollection: cartLineCollection,
    } as AddCartLinesApiParameter;

    await addLineCollection(parameter);
};
export const LoadCart: HandlerType = props => {
    props.dispatch(loadCurrentCart({ getPromotions: true }));
};

export const PromotionCartEndedLoaded: HandlerType = props => {
    props.dispatch({
        type: "Custom/PromotionCart/BeginEndedProducts",
    });
};

export const chain = [PromotionCartBeingLoaded, PromotionCartAPICall, LoadCart, PromotionCartEndedLoaded];

const promotionCartHandler = createHandlerChainRunner(chain, "PromotionCartHandler");
export default promotionCartHandler;
